module.exports = __webpack_public_path__ + "png/payment-way2.png?621e317b35c21fffed7dc7b6113bd686";